export default __webpack_public_path__ + "static/media/pin.78a46179.svg";